import Box from '@mui/material/Box';
import * as React from 'react';
import {useState} from 'react';
import {TabPanel} from '../../components/other/tabPanel';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import {StyledTab, StyledTabs} from './admin';
import BedImport from './ward/bedImport';
import EscalationLevel from './ward/escalationLevel';
import WardAssessments from './ward/wardAssessments';
import DischargeTemplate from './ward/dischargeTemplate';

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: '#448FFF',
    },


}));

function Ward_admin(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const [tab, setTab] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <>
            <Box sx={{width: '100%'}}>
                <Box sx={{borderBottom: 1, borderColor: 'divider', display: 'flex'}}>
                    <StyledTabs
                        value={tab}
                        TabIndicatorProps={{className: classes.indicator}}
                        onChange={handleChangeTab}
                    >
                        <StyledTab value={0} label={t('Ward Escalation Levels')}/>
                        {/*<StyledTab value={1} label={t('Bed Import')}/>*/}
                        <StyledTab value={2} label={t('Assessments')}/>
                        <StyledTab value={3} label={t('ED Discharge Templates')}/>
                    </StyledTabs>
                </Box>

                <TabPanel value={tab} index={0}>
                    <EscalationLevel/>
                </TabPanel>

                <TabPanel value={tab} index={1}>
                    <BedImport/>
                </TabPanel>

                <TabPanel value={tab} index={2}>
                    <WardAssessments/>
                </TabPanel>

                <TabPanel value={tab} index={3}>
                    <DischargeTemplate/>
                </TabPanel>
            </Box>
        </>
    );
}

export default Ward_admin;